// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const ogerpon: PokeData = {
  "id": 1017,
  "name": "ogerpon",
  "height": 12,
  "weight": 398,
  "base_experience": 275,
  "types": [
    PokeType.GRASS
  ],
  "api_moves": [
    "slam",
    "vine-whip",
    "leech-seed",
    "growth",
    "quick-attack",
    "focus-energy",
    "synthesis",
    "follow-me",
    "superpower",
    "power-whip",
    "wood-hammer",
    "low-sweep",
    "spiky-shield",
    "throat-chop",
    "ivy-cudgel"
  ],
  "moves": [
    "vine-whip",
    "quick-attack",
    "synthesis",
    "superpower",
    "power-whip",
    "wood-hammer",
    "overgrowth",
    "razor-leaf",
    "aromatherapy",
    "branch-poke",
    "bullet-seed",
    "frenzy-plant",
    "flower-rush"
  ],
  "evolution_chain": {
    "id": 543,
    "item": null,
    "species": [
      {
        "name": "ogerpon",
        "order": 1019,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 108,
    "speed": 140,
    "ability_power": 152
  },
  "stat_changes": [],
  "catch_rate": 5,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
